import { constructionAsset, constructionEquipment, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'Công trường xây dựng thường có nhiều rủi ro hơn so với các ngành công nghiệp khác. Vì vậy, an toàn của người lao động phải được ưu tiên hàng đầu. Trong môi trường có rủi ro cao này, việc không đảm bảo an toàn cho người lao động không chỉ gây trở ngại cho dự án mà còn có thể dẫn đến các vấn đề pháp lý. Nói cách khác, đây có thể coi là yếu tố quan trọng và mang tính sống còn nhất trong ngành xây dựng.\nNhiều tai nạn an toàn xảy ra do người lao động không trang bị đúng các thiết bị bảo hộ. Hơn nữa, tai nạn thường xảy ra trong khoảnh khắc rất ngắn, và việc không có biện pháp xử lý kịp thời có thể dẫn đến tử vong. Tuy nhiên, với công nghệ theo dõi vị trí thời gian thực (RTLS), chúng ta có thể theo dõi và quản lý người lao động cũng như tình hình tại công trường theo thời gian thực, từ đó tạo ra một môi trường xây dựng an toàn hơn nhiều. Không chỉ về an toàn, công nghệ này còn giúp cải thiện đáng kể hiệu quả dự án thông qua việc quản lý vật tư xây dựng, quản lý thiết bị nặng và phân tích lộ trình di chuyển của người lao động.',
  keywords:
    'An toàn xây dựng, An toan xay dung, An toàn lao động, An toan lao dong, An toàn công trường xây dựng, An toan cong truong xay dung, Quản lý an toàn xây dựng, Quan ly an toan xay dung',
  ogSite: 'Hệ thống quản lý an toàn công trường xây dựng thông minh',
  title: 'Hệ thống quản lý an toàn công trường xây dựng thông minh',
  ogUrl: 'https://orbro.io/vi/blog/smartConstruction',
  ogImg: '',
  ogType: 'website',
  date: '2023-07-31',
  tag1: '#Antoanxaydung',
  tag2: '#Antoanlaodong',
  tag3: '#Antoancongtruongxaydung',
  tag4: '#Quanlyantoanxaydung',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Công trường xây dựng thường có nhiều rủi ro hơn so với các ngành công nghiệp khác. Vì vậy, an toàn của người lao động phải được ưu tiên hàng đầu. Trong môi trường có rủi ro cao này, việc không đảm bảo an toàn cho người lao động không chỉ gây trở ngại cho dự án mà còn có thể dẫn đến các vấn đề pháp lý. Nói cách khác, đây có thể coi là yếu tố quan trọng và mang tính sống còn nhất trong ngành xây dựng.\n\nNhiều tai nạn an toàn xảy ra do người lao động không trang bị đúng các thiết bị bảo hộ. Hơn nữa, tai nạn thường xảy ra trong khoảnh khắc rất ngắn, và việc không có biện pháp xử lý kịp thời có thể dẫn đến tử vong. Tuy nhiên, với công nghệ theo dõi vị trí thời gian thực (RTLS), chúng ta có thể theo dõi và quản lý người lao động cũng như tình hình tại công trường theo thời gian thực, từ đó tạo ra một môi trường xây dựng an toàn hơn nhiều. Không chỉ về an toàn, công nghệ này còn giúp cải thiện đáng kể hiệu quả dự án thông qua việc quản lý vật tư xây dựng, quản lý thiết bị nặng và phân tích lộ trình di chuyển của người lao động.\n\nDưới đây, chúng tôi sẽ trình bày cách công nghệ này sẽ thay đổi và phát triển các công trường xây dựng như thế nào.',
      dot: '',
    },
    {
      head: '',
      subHead: '1. Quản lý việc sử dụng thiết bị bảo hộ',
      desc: 'Việc sử dụng thiết bị bảo hộ là một quy tắc an toàn cơ bản và thiết yếu nhất tại công trường xây dựng. Tuy nhiên, vì nhiều lý do, người lao động đôi khi không trang bị đúng cách. Sự phiền phức, bất tiện hoặc lơ là cuối cùng có thể dẫn đến những tai nạn nghiêm trọng.\nHệ thống có thể đánh giá theo thời gian thực liệu người lao động có đang sử dụng thiết bị bảo hộ hay không, và nếu vị trí hiện tại của họ là khu vực có nhiều yếu tố nguy hiểm, việc quản lý sẽ càng được chú trọng hơn. Người quản lý có thể theo dõi tình hình này theo thời gian thực để đưa ra cảnh báo hoặc các biện pháp xử lý tương ứng. Nếu tai nạn xảy ra, dữ liệu này cũng có thể được sử dụng như một nguồn thông tin quan trọng để tìm hiểu tình hình lúc đó.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Theo dõi vị trí thời gian thực',
      desc: 'Khi cần nhanh chóng xác định vị trí của một người lao động cụ thể, hoặc khi cần nắm bắt tình hình tổng thể của nhân sự tại hiện trường, vị trí của những người lao động được theo dõi theo thời gian thực sẽ hiển thị trên màn hình giám sát. Vị trí di chuyển theo thời gian thực của người lao động trên bản đồ mô phỏng giống hệt hiện trường giúp việc nắm bắt và đánh giá tình hình trở nên nhanh chóng.\nHoặc, có thể sử dụng công nghệ Geofence để thiết lập các khu vực nguy hiểm cụ thể, và gửi cảnh báo theo thời gian thực nếu có người lao động đi vào khu vực đó.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Quản lý hiệu quả làm việc',
      desc: 'Có thể nắm bắt được lộ trình di chuyển, thời gian lưu trú, thời gian nghỉ ngơi của người lao động. Điều này giúp hiểu rõ đặc điểm làm việc của từng người và thu thập dữ liệu cần thiết để cải thiện quy trình tổng thể cũng như hiệu quả của dự án.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Quản lý thiết bị nặng',
      desc: 'Không chỉ có người lao động di chuyển tại công trường. Đặc biệt về mặt an toàn, thiết bị nặng cũng là đối tượng cần được xem xét kỹ lưỡng. Theo dõi thiết bị nặng theo thời gian thực và gửi cảnh báo ngay lập tức nếu chúng đến gần người lao động tại hiện trường. Người quản lý có thể phát hiện sớm nguy cơ va chạm.\nNgoài ra, việc theo dõi thiết bị nặng theo thời gian thực còn liên quan đến hiệu quả sử dụng thiết bị. Có thể bố trí tối ưu các thiết bị cần thiết tại hiện trường và xác định lộ trình di chuyển nhanh nhất để tiết kiệm thời gian. Điều này cũng mang lại lợi thế trong việc quản lý tồn kho và bảo trì.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết luận',
      desc: 'Từ trước đến nay, người quản lý thường phải trực tiếp quan sát hiện trường để đánh giá và đưa ra chỉ thị. Tuy nhiên, giờ đây, với công nghệ mới, việc quản lý an toàn công trường xây dựng một cách thông minh đã trở nên khả thi. Không chỉ dừng lại ở an toàn, công nghệ này còn giúp nâng cao hiệu quả và năng suất của các dự án xây dựng, đồng thời hỗ trợ quy trình làm việc có hệ thống hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
